import React, { useEffect, useState } from "react";
import style from "./Response.module.css"; // Import CSS module
import { useHistory } from "react-router";
import { connect, useDispatch } from "react-redux";
import axiosHandler from "../../Services/axiosHandler";
import {
  showSnackbarAction,setCurrentRoute
} from '../../Redux/actions'
import { url} from "../../Values/constants";
import {fetchSingleMBData} from "../../Services/contacts"
import moment from "moment";
import Lottie from "react-lottie";
import noData from "../../Assets/animations/no-data.json";
import { useLocation } from 'react-router-dom';

type props = {
  user: any;
};

interface Stats {
  [key: string]: number; // A dynamic object to represent month names and their counts
}

// Function to check if today is the last day of the month
const isLastDayOfMonth = (date: Date): boolean => {
  const nextDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
  return nextDay.getDate() === 1; // If the next day is the 1st of the next month, today is the last day
};

// Function to get the last three or four months dynamically
const getDynamicMonthsStats = (allStats: Stats): Stats => {
  const currentDate = new Date();
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const result: Stats = {};

  // Determine whether to fetch three or four months
  const monthCount = isLastDayOfMonth(currentDate) ? 3 : 4;

  // Calculate the required months
  for (let i = 0; i < monthCount; i++) {
    const monthIndex = (currentDate.getMonth() - i + 12) % 12; // Wrap around for negative indices
    const monthName = months[monthIndex];
    if (allStats[monthName]) {
      result[monthName] = allStats[monthName];
    }
  }

  return result;
};

const getCurrentMonthDates = () => {
  const currentDate = new Date();
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const firstDay = new Date(currentYear, currentMonth, 1).getTime(); // Epoch time for the 1st of the current month
  const lastDay = new Date(currentYear, currentMonth + 1, 0).getTime(); // Epoch time for the last day of the current month
  const currentMonthName = months[currentMonth];
// console.log("currentMonth",currentMonthName)
  return { firstDay, lastDay,currentMonthName };
};

const Response: React.FC<props> = ({
  user
}) => {
  const history = useHistory();
const [responses,setResponses]=useState([
      {appm: "",
      pdpUrl: "",
      contactedOn: "",
      isdCode: "",
      encEmail: "",
      emailUuid: "",
      sentOn: "",
      contact: "",
      prjNm: "",
      addr: "",
      email: "",
      prc: "",
      cg: "",
      encMobile: "",
      mobileUuid: "",
      message: "",
      userId: "",
      topMatchesUrl: "",
      mbLeadRfnum: "",
      name: "",
      userType: "",
      contactOnDate: ""}
  ])
// const [responses,setResponses]=useState()
  const { firstDay, lastDay,currentMonthName } = getCurrentMonthDates();
const uid = user.user_oid
  const [startDate, setStartDate] = useState<number>(firstDay);
  const [endDate, setEndDate] = useState<number>(lastDay);
  const dispatcher = useDispatch();
  // const [total, setTotal] = useState<number>(0);
  const initialStats: Stats = {
    Nov: 0,
    Oct: 0,
    Sep: 0,
    Aug: 0,
  };
  const [allStats, setAllStats] = useState<Stats>(initialStats);
  const [nextPageAvailable, setNextPageAvailable] = useState(true);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [subUsers, setSubUsers] = useState<any[]>([]);
  const [mon, setMon]= useState(currentMonthName)
  const [page,setPage]=useState("0")
  const [showMessage, setShowMessage] = useState(false);
  const [selectedSubUser, setSelectedSubUser] = useState<any | null>(user.user_oid);

  const [cRoute,setCRoute]=useState("") 
      
           const location = useLocation();
            
              useEffect(() => {
                dispatcher(setCurrentRoute(location.pathname))
                setCRoute(location.pathname)
              }, [location]);
    
  // const [pageSize,setPageSize]=useState("20")
  // Dummy data for all monthly statistics
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: noData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  

  // Get the required months' stats based on the condition
// console.log("subUsers",subUsers)
// console.log("selectedSubUser",selectedSubUser)
  const stats = getDynamicMonthsStats(allStats);
  useEffect(()=>{
    setSelectedSubUser(user.user_oid)
    setResponses([])
  },[user.user_oid])

  

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMessage(true);
    }, 4000); // Delay of 2 seconds

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, [page,mon]);

  const fetchcount = async () => {
    const apiUrl = url+"/mbResponses/count";
  
    const payload = {
      page: page,
      pagesize: "20",
      uids: [selectedSubUser===user.user_oid?[]:selectedSubUser],
      userType: "A",
      startDate: startDate,
      endDate: endDate,
    };
  
    try {
      // console.log("Fetching responses with payload:", payload);
  
      const countresponse = await axiosHandler.post(apiUrl, payload);

      // console.log("countresponse",countresponse)
      setAllStats(countresponse.data)
    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };



  const fetchResponses = async () => {
    const apiUrl = url+"/mbResponses/responses";
  
    const payload = {
      page: page,
      pagesize: "20",
      uids: [selectedSubUser===user.user_oid?[]:selectedSubUser],
      userType: "A",
      startDate: startDate,
      endDate: endDate,
    };
  
    try {
      //console.log(" payload:", payload);
  
      const response = await axiosHandler.post(apiUrl, payload);
      let newResponses
      // console.log("response",response)  
      if (response.data.responses && Array.isArray(response.data.responses)) {
       newResponses = response.data.responses;
       
  
        // setTotalCount(response.data.totalCount || 0); // Update total count
        // setPage((parseInt(page) + 1).toString()); // Increment page for next fetch
        setNextPageAvailable(response.data.nextPageAvailable); // Update availability of next page
      } else {
        setTotalCount(0); // No data
        setNextPageAvailable(false); // No more pages available
      }
      // console.log("newResponses",newResponses)
      setResponses(newResponses)

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };

  const fetchUsersResponses = async () => {
    const apiUrl = url + "/mbResponses/subuserresponses";
  
    // const payload = {
    //   uid: user.user_oid,
    // };
  
    try {
      // console.log("fetchUsersResponses payload:", payload);
  
      const subresponse = await axiosHandler.post(apiUrl);
  
      // Add "My Responses" as the default option
      const defaultOption = {
        name: "My Responses",
        id: uid,
      };
  
      // Safely handle the subUsers data
      const fetchedSubUsers = Array.isArray(subresponse.data?.subUsers)
        ? subresponse.data.subUsers
        : []; // Use an empty array if subUsers is undefined or not an array
  
      // Combine "My Responses" with the fetched subUsers
      setSubUsers([defaultOption, ...fetchedSubUsers]);
    } catch (error: any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
  
      // Ensure that "My Responses" is available even if the API call fails
      setSubUsers([
        {
          name: "My Responses",
          id: user.user_oid,
        },
      ]);
    }
  };
  
  

  useEffect(()=>{
    fetchUsersResponses()
  },[user.user_oid])


  useEffect(()=>{
    fetchcount()
    if(selectedSubUser){
      fetchResponses()
    }
  },[startDate,endDate,mon,selectedSubUser,page])


  // const calculateMonthDates = (month: string, isLastMonth: boolean): { startDate: number; endDate: number } => {
  //   const currentDate = new Date();
  //   const year = currentDate.getFullYear(); // Current year
  
  //   // Get the month index (0-based for JavaScript Date)
  //   const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
  
  //   // If it's the last month in the list, calculate start based on today's date
  //   if (isLastMonth) {
  //     const day = currentDate.getDate(); // Today's day
  //     const startDate = new Date(year, monthIndex, day, 0, 0, 0).getTime();
  //     const endDate = new Date(year, monthIndex + 1, 0, 23, 59, 59).getTime(); // Last day of the month
  //     return { startDate, endDate };
  //   }
  
  //   // For other months, calculate full month range
  //   const startDate = new Date(year, monthIndex, 1, 0, 0, 0).getTime();
  //   const endDate = new Date(year, monthIndex + 1, 0, 23, 59, 59).getTime();
  
  //   return { startDate, endDate };
  // };

  const calculateMonthDates = (month: string, isLastMonth: boolean): { startDate: number; endDate: number } => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonthIndex = currentDate.getMonth(); // 0-based for JavaScript Date
    
    // Get the month index (0-based for JavaScript Date)
    const monthIndex = new Date(`${month} 1, ${currentYear}`).getMonth();
    
    // Determine the correct year for the month
    const year = monthIndex > currentMonthIndex ? currentYear - 1 : currentYear;
  
    // If it's the last month in the list, calculate start based on today's date
    if (isLastMonth) {
      const day = currentDate.getDate(); // Today's day
      const startDate = new Date(year, monthIndex, day, 0, 0, 0).getTime();
      const endDate = new Date(year, monthIndex + 1, 0, 23, 59, 59).getTime(); // Last day of the month
      return { startDate, endDate };
    }
  
    // For other months, calculate full month range
    const startDate = new Date(year, monthIndex, 1, 0, 0, 0).getTime();
    const endDate = new Date(year, monthIndex + 1, 0, 23, 59, 59).getTime();
  
    return { startDate, endDate };
  };
  

  const handleMonthClick = (month: string) => {

    const isLastMonth = month === Object.keys(initialStats).pop(); // Check if it's the last month
    const { startDate, endDate } = calculateMonthDates(month, isLastMonth);
    
    setPage("0")
    // Set state with epoch time
    setStartDate(startDate);
    setEndDate(endDate);
    if(mon!==month){
      setResponses([])
    }
    setMon(month)
    
    // console.log(`${month} startDate: ${startDate}, endDate: ${endDate}`);
  };

  const handleSubUserChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    setSelectedSubUser(selectedId);

    // Fetch data based on the selected sub-user
    // console.log("Selected SubUser ID:", selectedId);
    setPage("0");
    setResponses([]); // Clear current responses
    // Re-fetch data if required
  };

  const fetchMBData = async (leadId: string,uid:any) => {
    try {
  
        // let authToken = await firestore().collection('values').doc('constants').get();
        // let AUTHTOKEN = authToken.data()?.authToken ? authToken.data()?.authToken : "";
  
        let apiData =  {
          contact_id: leadId,
          uid:uid
        }
  // console.log("apiData",apiData)
      const backendUrl = url + "/mbResponses/fetchLeadByMB";
  
      const res = await axiosHandler.get(backendUrl, {params:apiData})
  
  // console.log("res",res)
        return res.data.data
  
  
    } catch (error) {
      dispatcher(
        showSnackbarAction(
          "Data Not Found!!",
          "warning"
        ))
      console.log('Lead fetching error', error);
      return {};
    }
  };

  const fetchData = async (contact_id:any) => {

    // console.log("VFCD","I rannnn1 1111",contact_id)
    if (contact_id) {
      try {
        // Assuming fetchSingleMBData is an async function that fetches data
        const data = await fetchMBData(contact_id,user.uid);
        // console.log("contact_details data",data)
        // Navigate to /contactDetails and pass contact_id in state

       if(data.transfer_status===false){ const formatDate = (date:string) => {
          return date && moment(date).toDate()
        };
        history.push({
          pathname: "/contactDetails",
          state: { detail:{  ...data,
            created_at: formatDate(data['created_at']),
            lead_assign_time: formatDate(data['lead_assign_time']),
            next_follow_up_date_time: formatDate(data['next_follow_up_date_time']),
            modified_at: formatDate(data['modified_at']),
            stage_change_at: formatDate(data['stage_change_at']),
            feedback_time: formatDate(data['feedback_time']),
            due_date: formatDate(data['due_date']),
            contactId:data['Id']
          } } // You can also pass the fetched data if needed
        });
      }else if(data.transfer_status===true){
        dispatcher(
          showSnackbarAction(
            "Lead Transferred to another User!!",
            "warning"
          ))
      }
      } catch (error) {
        dispatcher(
          showSnackbarAction(
            "No data found!!",
            "warning"
          ))
        console.error("Error fetching contact data", error);
      }
    }
  };

  // console.log("responses111111",responses)
// console.log("allStats",allStats)
  return (
    <div className={style.responseContainer}>
      {/* Header */}
      <div className={style.header}>
        <h3>My Responses (Last 3 Months)</h3>

        {/* Dropdown Menu */}
        <select
          className={style.subUserDropdown}
          value={selectedSubUser || ""}
          onChange={handleSubUserChange}
        >
          <option value="" disabled>
            Select Sub-User
          </option>
          {subUsers?.map((subUser:any) => (
            <option key={subUser.id} value={subUser.id}>
              {subUser.name}
            </option>
          ))}
        </select>
      </div>

      {/* Display Monthly Stats as Buttons */}
      <div className={style.stats}>
        {Object.entries(allStats).map(([month, count]) => (
          <button
            key={month}
            className={`${style.statsButton} ${mon === month ? style.selectedMonth : ''}`} // Apply the "selectedMonth" class
            onClick={() => handleMonthClick(month)}
          >
            {month} ({count})
          </button>
        ))}
      </div>

      {/* Toggle Button */}
      <div className={style.switchView}>
        <button
          className={style.toggleView}
          onClick={() => history.push("/propwiseresponse")}
        >
          Switch to Property-wise display
        </button>
      </div>

      {/* Responses List */}
      {responses===undefined?
          <div>
            {showMessage && (
              <>
                <Lottie options={defaultOptions} height={300} width={300} />
                <h5 className="text-center">No data Available</h5>
              </>
            )}
          </div>
          :
          <div className={style.responseList}>
        {responses.map((response, index) => (
          <div key={index} className={style.responseCard} 
          onClick={()=>fetchData(response.mbLeadRfnum)}
          >
            {/* Header Section */}
            <div className={style.cardHeader}>
              <span className={style.initial}>{response.name.charAt(0)}</span>
              <div>
                <h4>{response.name?response.name:""}</h4>
                <span>{response.userType}</span>
              </div>
              <div className={style.verifiedStatus}>
                <p>
                  Contact: <span style={{color:"#229954"}}>verified</span>
                </p>
                <p>
                  Email ID: <span style={{color:"#229954"}}>verified</span>
                </p>
              </div>
            </div>

            {/* Content Section */}
            <div className={style.cardContent}>
              <span className={style.tag}>Buy</span>
              <p>
                User contacted <strong>{response.prjNm}</strong>
              </p>
              <p>
                Looking for projects in <strong>{response.addr}</strong>
              </p>
              <p>
                Price Range: <strong>{response.prc}</strong>
              </p>
              <p>
                <em>{response.message}</em>
              </p>
              <p className={style.receivedDate}>Received on {response.sentOn}</p>
            </div>
          </div>
        ))}
      </div>}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {page !== "0" ? (
          <div className={style.switchView}>
            <button
              className={style.toggleView}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" })
                setPage((parseInt(page) - 1).toString())
              }}
            >
              {"<"} Previous Page
            </button>
          </div>
        ) : (
          <div style={{ width: "120px" }}></div> 
        )}
        {nextPageAvailable && (
          <div className={style.switchView}>
            <button
              className={style.toggleView}
              onClick={() => 
                // Scroll to the top of the screen
                {window.scrollTo({ top: 0, behavior: "smooth" })
                setPage((parseInt(page) + 1).toString())
              }}
            >
              Next Page {">"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(Response);

// export default Response;
// onClick={() => setPage((parseInt(page) - 1).toString())}
// onClick={() => setPage((parseInt(page) + 1).toString())}